import Authorization from './Authorization';

const MISSING_NAME = 'MISSING NAME';

export const hasName = (auth: Authorization): boolean => auth?.name !== MISSING_NAME;

export const filterAuthorizations = (authorizations: Authorization[] = []): Authorization[] =>
  authorizations?.filter(hasName)?.filter((auth) => auth?.active);
